import React, { useEffect, useState, useRef } from "react";
import "../Css/Header.css";
import logoRadisan from "../Resources/Images/logoRadisan.png";
import searchIcon from "../Resources/Images/searchIcon.svg";
import arrow from "../Resources/Images/arrow.svg";
import { UseTicket, SetTicket } from "../Js/Context/TicketCntx";

export function Header(props) {
    const { setSearchTickets, navbarItem, ticketPrp } = props;
    const setTicket = SetTicket();
    const ticket = UseTicket();
    const [states, setStates] = useState({
        SearchPlaceholder: "جستجو در میان تیکت ها ...",
        MobileWidth: false,
        SearchTicket: ""
    });
    const inputRefs = {
        SearchInput: useRef(null),
        HeaderSearchTickets: useRef(null),
        Popover: useRef(null),
        Arrow: useRef(null),
    };

    useEffect(() => {
        const checkWindowWidth = (event) => {
            const windowWidth = window.innerWidth;
            if (windowWidth < 800) {
            //    inputRefs.SearchInput.current.style.display = "none";
            //    inputRefs.HeaderSearchTickets.current.style.width =
            //        "fit-content";
            } else {
                //inputRefs.SearchInput.current.style.display = "block";
                //inputRefs.HeaderSearchTickets.current.style.width = "30%";
                //inputRefs.Popover.current.style.width = "calc(100% - 45px)";
                //inputRefs.Popover.current.style.height = "fit-content";
                //inputRefs.Arrow.current.style.display = "none";
                setStates((prevState) => ({
                    ...prevState,
                    SearchPlaceholder: "جستجو در میان تیکت ها ...",
                    MobileWidth: false,
                }));
                //inputRefs.Popover.current.classList.remove("popover");
                //inputRefs.SearchInput.current.classList.remove("search-mobile");
            }
        };
        checkWindowWidth();
        window.addEventListener("resize", checkWindowWidth);

        return () => {
            window.removeEventListener("resize", checkWindowWidth);
        };
    }, []);
    const handleSearch = () => {      
        const windowWidth = window.innerWidth;
        if (windowWidth < 800 && states.MobileWidth || windowWidth > 800) {
            setSearchTickets(states.SearchTicket)
        }else if (windowWidth < 800) {
            //inputRefs.Popover.current.style.width = "206px";
            //inputRefs.Popover.current.style.height = "86px";
            //inputRefs.Arrow.current.style.display = "block";
            setStates((prevState) => ({
                ...prevState,
                SearchPlaceholder: "کلمه کلیدی در عنوان",
                MobileWidth: true,
            }));
            inputRefs.SearchInput.current.classList.add("search-mobile");
        }
    };
    useEffect(()=>{
        setStates((prevState) => ({
            ...prevState,
            SearchTicket: ""
        }));
    },[navbarItem])
    return (
        <section id="header" className="flexRow">
            <img src={logoRadisan} style={{ margin: ticketPrp ? "" : "auto"}}></img>
            {/*<div*/}
            {/*    id="header-search-tickets"*/}
            {/*    className={`input-group-addon flexRow ${ticketPrp ? "" : "none"}`} */}
            {/*    ref={inputRefs.HeaderSearchTickets}*/}
            {/*>*/}
            {/*    <div*/}
            {/*        className={`${states.MobileWidth ? "popover" : ""}`}*/}
            {/*        style={{ width: "calc(100% - 45px)" }}*/}
            {/*        ref={inputRefs.Popover}*/}
            {/*    >*/}
            {/*        <img*/}
            {/*            className={`arrow none`}*/}
            {/*            src={arrow}*/}
            {/*            ref={inputRefs.Arrow}*/}
            {/*        ></img>*/}
            {/*        <h3*/}
            {/*            className={`${*/}
            {/*                states.MobileWidth == false*/}
            {/*                    ? "none"*/}
            {/*                    : "popover-title"*/}
            {/*            }`}*/}
            {/*        >*/}
            {/*            جستجو در میان تیکت ها ...*/}
            {/*        </h3>*/}
            {/*        <input*/}
            {/*            type="text"*/}
            {/*            name="keyword"*/}
            {/*            id="search"*/}
            {/*            placeholder={states.SearchPlaceholder}*/}
            {/*            value={states.SearchTicket}*/}
            {/*            className={`input`}*/}
            {/*            ref={inputRefs.SearchInput}*/}
            {/*            style={{ width: "100%" }}*/}
            {/*            onChange={(e)=>{*/}
            {/*                setStates((prevState) => ({*/}
            {/*                    ...prevState,*/}
            {/*                    SearchTicket: e.target.value*/}
            {/*                }));                          */}
            {/*            }}*/}
            {/*        />*/}
            {/*    </div>*/}

            {/*    <span*/}
            {/*        id="submit-search"*/}
            {/*        className="flexColumn"*/}
            {/*        onClick={handleSearch}*/}
            {/*    >*/}
            {/*        <img id="searchIcon" src={searchIcon}></img>*/}
            {/*    </span>*/}
            {/*</div>*/}
        </section>
    );
}
